export default (node) => {
  /**
   * Data + elements
   */
  const swiperContainer = node.querySelector('.swiper-container');
  const slides = swiperContainer.querySelectorAll('.swiper-slide');
  if (slides.length < 2) return; // 0/1 message => do nothing

  const prevButton = node.querySelector('.swiper-button-prev');
  const nextButton = node.querySelector('.swiper-button-next');

  /**
   * Functions
   */
  const initSwiper = () => {
    new Swiper(swiperContainer, {
      slidesPerView: 1, // all screensizes
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      allowTouchMove: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  };

  /**
   * Init
   */
  const init = () => {
    if (swiperContainer) {
      initSwiper();
    }
  };

  init();
};
